module.exports = __webpack_public_path__ + "img/nodata.5cdf5db0.svg";